module.exports = __webpack_public_path__ + "static/media/zw.a21f533d.svg";